module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Wenn der Staub sich legt")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("Von Mary Calmes")]), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("Buch 3 in der Serie – Timing")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Glenn Holloways berechenbares Leben endete an jenem Tag, als er seiner Familie gestand, dass er schwul ist. Dass er kurz darauf die Ranch, auf der er aufwuchs, verließ, um das Restaurant zu eröffnen, von dem er immer geträumt hatte, streute nur noch Salz in die Wunde. Ohne die Unterstützung seines Vaters und seines Bruders und zu stolz, um Hilfe von anderen zu akzeptieren, musste er ganz von vorne anfangen. Doch im Lauf der Zeit wendete sich das Blatt: Glenn führte sein Restaurant zum Erfolg, schuf sich ein neues Zuhause und ein Leben, auf das er stolz sein kann.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Doch trotz seines Erfolges ist die Entfremdung von den Holloways eine Wunde, die nicht richtig heilen will, und als er sich gezwungen sieht, einen erwiesenen Gefallen zurückzuzahlen, findet er sich in seinem schlimmsten Albtraum wieder. Gefangen in seinem einst gegebenen Versprechen kehrt Glenn zu seinen Wurzeln zurück, um seinem Halbbruder zu helfen, Rand Holloway, und wird mit Mac Gentry konfrontiert, einem Mann, der viel zu verlockend für Glenns Seelenfrieden ist. Es könnte alles in einer Katastrophe enden – einer Katastrophe für die zarten Annäherungen an eine Wiederversöhnung mit seiner Familie und für das Verlangen, von dem Glenn nicht einmal wusste, dass es in seinem Herzen ruht.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98ef6232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0001.vue
// module id = 57
// module chunks = 0